import { render, staticRenderFns } from "./Nav.vue?vue&type=template&id=0b14c3e6&scoped=true&"
var script = {}
import style0 from "./Nav.vue?vue&type=style&index=0&id=0b14c3e6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b14c3e6",
  null
  
)

export default component.exports